import {
  useHistory, useLocation
} from "react-router-dom";

import ArrowLeft from '@material-ui/icons/ChevronLeft';

import HelpButton from "../../header/HelpButton";
import LanguagePicker from "../../header/LanguagePicker";
import LogInOutButton from "../../header/LogInOutButton";

import { useStyles } from "../styles";

import { ReactComponent as GroupSettingsIcon } from "../../../assets/images/icon-groupSettings.svg";
import { useTranslation } from "react-i18next";
import { GROUPS_MANAGEMENT_URL, VENUES_OVERVIEW } from "../../../const/URL.const";

interface IHeader {
  title?: string;
}

export default function Header({ title }:IHeader) {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const classes = useStyles();

  function goBack(){
    if(location.pathname.includes('settings')){
      history.push(GROUPS_MANAGEMENT_URL)
    }else{
      history.push(VENUES_OVERVIEW)
    }
  }
  return (
      <header>
           <div>
              <ArrowLeft onClick={goBack}/>
              {!title && <GroupSettingsIcon />}
              <div className={classes.title}>{title ? title : t("header.groupSettings")}</div>
           </div>
           <div>
              <HelpButton />
              <LanguagePicker />
              <LogInOutButton />
           </div>
      </header>
  )
}
